import { ChangeEvent } from 'react';

import { theme } from 'shared/styles/theme';

import { Box } from './Box';
import { Icon } from './Icon';

import styled from '@emotion/styled';

const InputStyled = styled('input')({
  fontSize: theme.fontSizes[17],
  width: '100%',
  padding: '12px 12px',
  paddingRight: '40px',
  borderRadius: theme.space[4],
  outline: 'none',
  boxSizing: 'border-box',
  backgroundColor: `${theme.colors.white}`,
  border: 'none',
  height: '100%',
});

export const ClearButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
`;

export type InputProps = {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
  errorMessage?: string;
  placeholder?: string;
  onClearField?: () => void;
  inputProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
  width?: string;
} & Omit<React.ComponentProps<typeof Box>, 'onChange'>;

export const Input = ({ value, onChange, errorMessage = '', placeholder, onClearField, inputProps, ...rest }: InputProps) => (
  <Box position='relative' alignItems='center' width='100%' {...rest}>
    <InputStyled
      placeholder={placeholder}
      value={value ?? ''}
      onChange={(e) => onChange && onChange(e, e.target.value)}
      {...inputProps}
    />
    {onClearField && value !== undefined && (
      <ClearButton type='button' onClick={() => onClearField()}>
        <Icon name='close' width={24} height={24} />
      </ClearButton>
    )}
    {errorMessage && (
      <Box className='error' position='absolute' mt={2} color='red'>
        {errorMessage}
      </Box>
    )}
  </Box>
);
